import React from 'react';
import ReactDOM from 'react-dom';
import {FaRegularIcon, FaSolidIcon} from "../FontAwesomeIcons";
import styled from "styled-components"
import {swal} from "../../helpers/SweetAlertWrapper";

const RadioListGroupItemImage = styled.div`
width:40px;
height:40px;
background-position:center center;
background-repeat:no-repeat;
background-size:cover;
background-image:url(${props => props.image});
border-radius:50%;
`;

export default class RadioListGroup extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            selected: this.props.selected || null,
            itemsName: "RadioListGroup_" + (Math.random() * 1000).toFixed(0)
        };
    }

    handleChange = (value) => {
        this.setState({selected: value});
        this.props.onChange(value);
    }

    render() {
        return (
            <div>
                {!this.props.items.length ? 'Nessuna opzione selezionabile' : ''}
                {this.props.items.map((item, i) => {
                    return (
                        <ListGroupRadioItem
                            key={i}
                            name={this.state.itemsName}
                            checked={this.state.selected === item.value}
                            onChange={this.handleChange}
                            {...item}
                        />
                    )
                })}
            </div>
        )
    }

}


class ListGroupRadioItem extends React.Component {

    constructor(props) {
        super(props);
    }

    handleChange = (changeEvent) => {
        this.props.onChange(changeEvent.target.value);
    }

    handleImageClick = e => {
        e.stopPropagation();
        e.preventDefault();
        swal.fire({
            html: <img src={this.props.image} className={"img-fluid"}/>,
            showConfirmButton: false,
            showCloseButton: true,
            focusCancel: false, focusConfirm: false
        });
    }

    render() {
        return (
            <label className={"list-group-item bg-main-z2 px-0"}>
                <div className="container-fluid">
                    <div className={"row align-items-center"}>
                        <div className={(this.props.image ? "col-8" : "col-12")}>
                            <div className={"fux-radiobox  d-flex align-items-center"}>
                                <input type="radio" name={this.props.name} checked={this.props.checked}
                                       value={this.props.value} onChange={this.handleChange}/>
                                <span className="text-on-bg-main">
                                    {this.props.checked ?
                                        <FaSolidIcon name={"check-circle"} className={"mr-2 text-primary"}/> :
                                        <FaRegularIcon name={"circle__"}/>}
                                </span>
                                <div className={"text-on-bg-main flex-grow-1"}>{this.props.text}</div>
                            </div>
                            <div className={"small text-on-bg-main"}>{this.props.description}</div>
                        </div>
                        {
                            this.props.image ?
                                <div className={"col"}>
                                    <RadioListGroupItemImage onClick={this.handleImageClick} className={"mx-auto"}
                                                             image={this.props.image}/>
                                </div>
                                : ''
                        }
                    </div>
                </div>
            </label>
        )
    }

}
